import { createStore } from 'satcheljs';
import { FeedbackViewState } from './schema/FeedbackViewState';
import { InlineFeedbackDialogState } from './schema/InlineFeedbackDialogState';
import { ObservableMap } from 'mobx';
import { FeedbackRibbonStore } from './schema/FeedbackRibbonStore';
import { FeedbackRibbonState } from './schema/FeedbackRibbonState';
import { FeedbackCategory } from '../components/InlineFeedbackDialog';

var initialFeedbackViewState: FeedbackViewState = {
    selectedFeedbackArea: null,
    subject: '',
    message: '',
    classification: null,
    screenshotBlob: null,
    screenshotFileBase64: null,
    isIncludeDebugInfoChecked: true,
};

export var store = createStore<FeedbackViewState>('feedbackViewState', initialFeedbackViewState)();

export let inlineFeedbackDialogStore = createStore<InlineFeedbackDialogState>(
    'inlineFeedbackDialogStore',
    {
        showThankyouDialog: false,
        showInlineFeedbackDialog: false,
        inlineFeedbackResponseText: '',
        inlineFeedbackResponseCategories: [],
        isContentDonated: false,
        isSubmitDisabled: true,
        subCategories: new ObservableMap<string, FeedbackCategory[]>(),
    }
);

var initialFeedbackRibbonStore: FeedbackRibbonStore = {
    mountedRibbons: new ObservableMap<string, FeedbackRibbonState>(),
};

export let feedbackRibbonStore = createStore<FeedbackRibbonStore>(
    'feedbackRibbonStore',
    initialFeedbackRibbonStore
)();
